import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload-component.component.html',
  styleUrls: ['./file-upload-component.component.css']
})
export class FileUploadComponentComponent implements OnInit {

  @Input()
  public id: string;

  @Input()
  public accept: string;

  @Input()
  public multiple: boolean;

  @Output()
  public filesSet: EventEmitter<File[]> = new EventEmitter<File[]>();

  @Input()
  public text: string;

  constructor() { }

  public setFiles(event: any) {
    this.filesSet.emit(event.target.files);
    event.target.value = '';
  }

  ngOnInit() {
  }
}
